{
  "startTaxLossHarvesting": "Activer la réalisation des pertes fiscales",
  "youDontHavePermission": "Vous n'avez pas l'autorisation d'exécuter le travail de TLH",
  "newTLHJobRun": "Nouvelle tâche de réalisation de pertes fiscales",
  "newTLHJobStarted": "Le travail d'analyse de pertes fiscales est maintenant exécuté en arrière-plan.",
  "newTLHJobFailed": "La tâche d'analyse de pertes fiscales n'a pas pu démarrer. Réessayez plus tard.",
  "analysisOn": "analyse sur",
  "state": "État",
  "organization": "Organisation",
  "table": {
    "ranAt": "exécuté à",
    "numEvents": "# d'événements (négociations)",
    "state": "état",
    "organization": "organisation",
    "user": "Utilisateur",
    "account": "Compte",
    "symbol": "Symbole",
    "substituteSymbol": "Symbole de substitution",
    "costBase": "Base de coûts",
    "adjustedCostBase": "Prix de base rajusté",
    "price": "Prix",
    "sellQuantity": "Quantité",
    "expectedSellValue": "Valeur de vente attendue",
    "assetValueAsOf": "Valeur de cet actif en date du",
    "gainLossPercentage": "Gain (perte) %",
    "gainLossValue": "Gain (Perte) $",
    "bookValue": "Valeur comptable"
  },
  "errors": {
    "noSuchTLHJob": "Aucune tâche de réalisation de pertes fiscales"
  }
}
